import { IconButton } from '@mui/material';
import styled from '@mui/material/styles/styled';

// const StyledRoundIconButton = styled('button')(({ theme }) => ({
//   fontSize: 24,
//   '&:hover': {
//     color: theme.palette.secondary.main,
//     borderRadius: '50%',
//     backgroundColor: theme.palette.secondary.lightbg,
//   },
// }));

const StyledRoundIconButton = styled(IconButton)(({ theme }) => ({
  fontSize: 20,
  padding: 4,
  color: `#f2f2f2 !important`,
  backgroundColor: `#33CCCC !important`,
  '&:hover': {
    color: `#fff !important`,
    backgroundColor: `#33CCCC !important`,
    fontWeight: 'bold',
  },
}));

export default StyledRoundIconButton;
